import React from 'react';
import PropTypes from 'prop-types';

const SPACE = ' ';

function SimilarHeader({ copy, title, itemIsUnavailable }) {
    if (itemIsUnavailable) {
        return <h3 className="pdp-similar-header-title">{copy.soldSubheader}</h3>;
    }

    return (
        <h2 className="pdp-similar-header-title">
            {copy.header}
            {SPACE}
            <span className="pdp-similar-header-info">{title}</span>
        </h2>
    );
}

SimilarHeader.propTypes = {
    copy: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    itemIsUnavailable: PropTypes.bool,
};

module.exports = SimilarHeader;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Similar/SimilarHeader.jsx